import { useNavigate, useSearch } from '@tanstack/react-router';
import Tabs, { type TabItem } from '../../../../components/Tabs';
import type { OrganizationTabType } from '../pages/EditPage';
import useFetchIam from '../../api/useFetchIam';

const ORGANIZATION_TABS: (TabItem & { id: OrganizationTabType })[] = [
  { label: '全体設定', id: 'general' },
  { label: 'マイページ設定', id: 'portal' },
  { label: 'アカウント設定', id: 'account' },
  { label: 'メンバー管理', id: 'members' },
  { label: '外部連携', id: 'api' },
];

/** トライアルプランで非表示にするタブ */
const TRIAL_HIDDEN_TABS: OrganizationTabType[] = ['general', 'api'];

export default function OrganizationSettingsTabs() {
  const navigate = useNavigate({ from: '/agent/settings' });
  const search = useSearch({ from: '/agent/settings/' });
  const currentTab: OrganizationTabType = search.t ?? 'general';
  const { data: iam } = useFetchIam();
  const isTrial = iam?.plan_type === 'trial';

  const visibleTabs = isTrial
    ? ORGANIZATION_TABS.filter((tab) => !TRIAL_HIDDEN_TABS.includes(tab.id))
    : ORGANIZATION_TABS;

  return (
    <Tabs
      items={visibleTabs.map((tab) => ({
        ...tab,
        onClick: () =>
          navigate({
            to: '/agent/settings',
            search: (prev) => ({ ...prev, t: tab.id }),
            replace: true,
          }),
        current: currentTab === tab.id,
      }))}
      className="mt-4"
    />
  );
}
